import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../CommonControlls/TableRendrer";
import { Link } from "react-router-dom";
import {
    SelectPatientsList,
    SelectAllDistricts,
    SelectAllHCF,
    SelectAllProvince,
} from "../OfflineDb/IndexDbTranscSP";
import AlertModal from "../CommonControlls/AlertModal";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import DropDown from "../CommonControlls/DropdownRendrer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";

const mapStateToProps = (store) => {
    return store;
};

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings });
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading });
        },
    };
};

class Patients_List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Isloading: false,
            HCFList: [
                { id: 0, name: "RHC/PPM" },
                { id: 1, name: "BHU/GP" },
            ],
            HCFLoader: false,

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: [],

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: [],

            startDate: new Date(),
            endDate: new Date(),

            // Table
            data: [],
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,
            exportLoading: false,

            sortField: "id",
            idsortOrder: "desc",
            provinceNamesortOrder: "",
            districtNamesortOrder: "",
            hcfNamesortOrder: "",
            hcfTypesortOrder: "",
            namesortOrder: "",
            agesortOrder: "",

            exportingPdf: false,

            permissions: [],

            SrList: [],
            FilteredSrs: [],
            SrId: [],
            facilityTypes: [
                { id: "1-a", name: "BHU" },
                { id: "1-b", name: "GP" },
                { id: "2-a", name: "RHC" },
                { id: "2-b", name: "PPM" },
            ],
            facilityTypeId: '',

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },
        };
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login");
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_Patients");
        this.GetPageConfigData(() => {
            this.PopulateTable();
        });
        // this.PopulateTable()
        $(".Search_InputField").on("keypress", (e) => {
            if (e.which === 13) {
                this.PopulateTable();
            }
        });

        this.SelectSubReciepents();
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_RolesPermissions,
            {
                pageSize: 15,
                pageNumber: 1,
            },
            (resp) => {
                const modifiedPermissions = resp.data
                    .filter(
                        (p) => p.permissioN_GROUP === "Patient" && p.permissioN_ALLOWED
                    )
                    .map((d) => d.permissioN_NAME);
                this.setState({ permissions: modifiedPermissions });
            }
        );
    }

    HandleDateChange = (Field, date) => {
        this.setState(
            { [Field]: date === "" || date == null ? new Date() : date },
            () => {
                if (
                    Field === "startDate" &&
                    this.state.startDate > this.state.endDate
                ) {
                    this.setState({ endDate: this.state.startDate });
                }
            }
        );
    };
    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState(
            {
                [fieldId]: value,
                // isSaveSearch: this.state.isSearchChanged ? true : false
            },
            () => {
                if (fieldId === "ProvinceId") {
                    this.FilterDistricts(value);
                }
                if (fieldId === "SrId") {
                    var selectedSrs = this.state.SrId;
                    const tempDistricts = this.state.Districtlist;
                    var filteredSrsId = Common.ConvertToCommaSplitArray(
                        selectedSrs,
                        "id"
                    );
                    var filteredSelectedDistricts = tempDistricts.filter(function (obj) {
                        return filteredSrsId.indexOf(obj.subrecipientid) > -1;
                    });
                    this.setState({
                        FilteredDistrictlist: filteredSelectedDistricts,
                    });
                }
                // if(fieldId === 'DistrictId') {
                //     var selectedDistricts = this.state.DistrictId
                //     var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(selectedDistricts, "id")
                //
                //     const TempSr = this.state.SrList
                //     const filtered = TempSr.filter((el) => {
                //         return filteredDistrictIdArr.indexOf(el.districtId) > -1
                //     })
                //
                //     this.setState({
                //         FilteredSrs: filtered
                //     })
                // }
            }
        );
    };
    FilterDistricts = (value) => {
        // filter ditrict list
        var TempArr = this.state.Districtlist;
        var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
        var filteredDistrictList = TempArr.filter(function (obj) {
            return selectedProvince.indexOf(obj.provinceId) > -1;
        });

        const tempSrs = this.state.SrList;
        const filteredSrs = tempSrs.filter(
            (item) => selectedProvince.indexOf(item.provinceid) > -1
        );

        // filter district selected values
        var selectedDistricts = this.state.DistrictId;
        var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(
            filteredDistrictList,
            "id"
        );
        var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
            return filteredDistrictIdArr.indexOf(obj.id) > -1;
        });

        this.setState({
            // FilteredDistrictlist: filteredDistrictList,
            // DistrictId: filteredSelectedDistricts
            FilteredSrs: filteredSrs,
        });
    };

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({ Isloading: true });
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        this.SelectHCF(() => {
            d1.resolve();
        });
        this.SelectDistricts(() => {
            d2.resolve();
        });
        this.SelectProvinces(() => {
            d3.resolve();
        });
        $.when(d1, d2, d3).done(() => {
            this.props.ShowLoader({ Isloading: false });
            CallBack();
        });
    };

    RegisterUnregisterPatient = (id, status) => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "POST",
            false,
            Common.APILinks.Update_PatientState,
            {
                patient_id: id,
                is_registered: status,
            },
            (resp) => { }
        );
    };

    UpdatePatientDiagnosed = (id, diagnosed) => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "POST",
            false,
            Common.APILinks.Update_PatientDiagnosed,
            {
                patient_id: id,
                is_clinicallyDiagnosed: diagnosed,
            },
            (resp) => { }
        );
    };
    SelectHCF = (Callback) => {
        this.setState({ HCFLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AutToken,
            "GET",
            false,
            Common.APILinks.SelectAll_HCF,
            {},
            (data) => {
                this.setState({
                    HCFList: data.data,
                    HCFLoader: false,
                });
                Callback();
            },
            (error) => {
                this.setState({ HCFLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectProvinces = (Callback) => {
        this.setState({ ProvinceLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Province,
            {},
            (data) => {
                this.setState({
                    ProvinceLoader: false,
                    Provincelist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ ProvinceLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_District,
            {},
            (data) => {
                this.setState({
                    DistrictLoader: false,
                    Districtlist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ DistrictLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        if (type === "sort") {
            let tempFieldorderLabel = sortField + "sortOrder";
            let tempFieldorder =
                this.state[tempFieldorderLabel] === ""
                    ? sortOrder
                    : this.state[tempFieldorderLabel] === "asc"
                        ? "desc"
                        : "asc";
            this.setState(
                {
                    sortField,
                    [tempFieldorderLabel]: tempFieldorder,
                },
                () => {
                    this.PopulateTable();
                }
            );
            return;
            // let result = this.state.data
            // // Handle column sort
            // if (sortOrder === 'asc') {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return 1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return -1;
            //     }
            //     return 0;
            //     });
            // } else {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return -1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return 1;
            //     }
            //     return 0;
            //     });
            // }
            // return
        }
        this.setState(
            {
                page,
                sizePerPage,
            },
            () => {
                this.PopulateTable();
            }
        );
    };
    ExportPdf = () => {
        const doc = new jsPDF();

        this.setState({ exportingPdf: true });
        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            name: $("#SearchName").val(),
            contact: $("#SearchContact").val(),
            pageSize: this.state.TotalRecord,
            pageNumber: this.state.page,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            provinceIdString,
            districtIdString,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            sortField: this.state.sortField,
            gender: $("#gender").val(),
            category: this.state.category,
            facilityType: String(this.state.facilityTypeId).charAt(0),
            subrecipientId: subRecipientIdString,
            PatientSampleId: $("#sampleId").val(),
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_Patients,
            Parameters,
            (resp) => {
                if (resp.status) {
                    if (resp.data.length > 0) {
                        var ProcessedHcf = Common.ProcessDataInArray(
                            this.state.HCFList,
                            "id"
                        );
                        for (var i in resp.data) {
                            resp.data[i].hcfType = ProcessedHcf[resp.data[i]?.hcfId]?.typeId;
                            resp.data[i].facilityType =
                                (+resp.data[i].facilityType === 1 && "BHU/GP") ||
                                (+resp.data[i].facilityType === 2 && "RHC/PPM");
                            resp.data[i].gender =
                                (+resp.data[i].gender === 1 && "Male") ||
                                (+resp.data[i].gender === 2 && "Female") ||
                                "Other";
                        }
                        doc.autoTable({
                            theme: "grid",
                            body: [...resp.data],
                            columns: [
                                { header: "id", dataKey: "id" },
                                { header: "Name", dataKey: "name" },
                                { header: "HCF Type", dataKey: "hcfType" },
                                { header: "Address", dataKey: "address" },
                                { header: "Contact", dataKey: "contact" },
                                { header: "Category", dataKey: "category" },
                                { header: "Registered", dataKey: "is_registered" },
                                { header: "Diagnosed", dataKey: "is_clinicallyDiagnosed" },
                                { header: "Facility Type", dataKey: "facilityType" },
                                { header: "Gender", dataKey: "gender" },
                                { header: "CNIC #", dataKey: "cnic" },
                                { header: "Province", dataKey: "provinceName" },
                                { header: "Tehsil", dataKey: "tehsilName" },
                                { header: "District", dataKey: "districtName" },
                            ],
                        });

                        doc.save("patients.pdf");
                        this.setState({ exportingPdf: false });
                    }
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    SelectSubReciepents = () => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectALl_SubRecipient,
            {},
            (resp) => {
                if (resp.status) {
                    this.setState({
                        SrList: resp.data.map((d) => ({
                            id: d.id,
                            name: d.short_name,
                            districtId: d.districtid,
                            ...d,
                        })),
                    });
                }
            }
        );
    };
    ExportData = (size) => {
        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            name: $("#SearchName").val(),
            contact: $("#SearchContact").val(),
            pageSize: this.state.TotalRecord,
            pageNumber: this.state.page,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            provinceIdString,
            districtIdString,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            sortField: this.state.sortField,
            gender: $("#gender").val(),
            category: this.state.category,
            facilityType: String(this.state.facilityTypeId).charAt(0),
            subrecipientId: subRecipientIdString,
            PatientSampleId: $("#sampleId").val(),
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_Patients_Download,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.setState({
                    csvFileLink: Common.BaseUrlAPI + resp.csvFileLink,
                    exportLoading: false,
                });
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    PopulateTable = () => {
        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ loading: true, data: [], TotalRecord: 0 });

        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            name: $("#SearchName").val(),
            contact: $("#SearchContact").val(),
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            provinceIdString,
            districtIdString,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            sortField: this.state.sortField,
            gender: $("#gender").val(),
            category: this.state.category,
            facilityType: String(this.state.facilityTypeId).charAt(0),
            subrecipientId: subRecipientIdString,
            PatientSampleId: $("#sampleId").val(),
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_Patients,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    if (resp.data.length > 0) {
                        var ProcessedHcf = Common.ProcessDataInArray(
                            this.state.HCFList,
                            "id"
                        );
                        // var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
                        // var ProcessedDistricts= Common.ProcessDataInArray(this.state.Districtlist,"id")
                        for (var i in resp.data) {
                            // resp.data[i].hcfName= resp.data[i].hcfId==null||resp.data[i].hcfId==""?"": ProcessedHcf[resp.data[i].hcfId].name
                            resp.data[i].hcfType = ProcessedHcf[resp.data[i].hcfId]?.typeId;
                            resp.data[i].facilityType =
                                (+resp.data[i].facilityType === 1 && "BHU/GP") ||
                                (+resp.data[i].facilityType === 2 && "RHC/PPM");
                            // resp.data[i].provinceName= ProcessedProvince[ProcessedHcf[resp.data[i].hcfId].provinceId].name
                            // resp.data[i].districtName= ProcessedDistricts[ProcessedHcf[resp.data[i].hcfId].districtId].name
                        }
                    }
                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.totalRecord,
                    });
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    onDelete = (id) => {
        this.setState(
            {
                alertModalData: {
                    title: "Delete Patient",
                    message: "Are you sure you want to delete this record.",
                    First_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                        this.DeleteRecord(id);
                    },
                    Second_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                    },
                    type: 1,
                },
            },
            () => {
                $("#Show_ArletModal").click();
            }
        );
    };
    DeleteRecord = (id) => {
        this.props.ShowLoader({ Isloading: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Delete_Patient,
            { id: id },
            (Result) => {
                if (Result.status) {
                    SyncConfig(
                        () => {
                            this.PopulateTable();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
                            setTimeout(function () {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        },
                        () => {
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: "Error in sync, please reload the page",
                            });
                            setTimeout(function () {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        }
                    );
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: Result.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    render() {
        const CellMenu = (cell, row) => {
            return (
                <div>
                    {this.state.permissions.includes("update-patient") && (
                        <Link to={`/Patients_Edit/${row.id}`}>
                            <button
                                data-toggle="tooltip"
                                title="Edit"
                                class="btn TableRow_btn"
                            >
                                <i
                                    class="fa fa-pencil-square-o text-primary"
                                    aria-hidden="true"
                                ></i>
                            </button>
                        </Link>
                    )}

                    {this.state.permissions.includes("delete-patient") && (
                        <button
                            onClick={() => this.onDelete(row.id)}
                            data-toggle="tooltip"
                            title="Delete"
                            class="btn TableRow_btn"
                        >
                            <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
                        </button>
                    )}
                </div>
            );
        };

        const columns = [
            {
                dataField: "provinceName",
                text: "Province",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "102px", fontSize: "13px" };
                },
                // hidden:  this.props.UserAuthentication?.UserInfo?.roleId === 8 ? false : true,
                csvExport: true,
            },
            {
                dataField: "patientSampleId",
                text: "Sample Id",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "90px", fontSize: "13px" };
                },
            },
            {
                dataField: "districtName",
                text: "District",
                headerStyle: (colum, colIndex) => {
                    return { width: "97px", fontSize: "13px" };
                },
                sort: true,
                // hidden:  this.props.UserAuthentication.UserInfo?.roleId === 8 ? false : true,
                csvExport: true,
            },
            {
                dataField: "category",
                text: "Category",
                headerStyle: (colum, colIndex) => {
                    return { width: "86px", fontSize: "13px" };
                },
            },
            {
                dataField: "subRecipientname",
                text: "SR Name",
                headerStyle: (colum, colIndex) => {
                    return { width: "110px", fontSize: "13px" };
                },
                sort: true,
                // hidden:  this.props.UserAuthentication.UserInfo?.roleId === 8 ? false : true,
                csvExport: true,
            },
            {
                dataField: "hcfName",
                text: "Patient Created At",
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", fontSize: "13px" };
                },
                sort: true,
                // hidden: this.props.UserAuthentication.UserInfo?.roleId === 8 ? false : true,
                csvExport: true,
            },
            {
                dataField: "hcfType",
                text: "Facility Type",
                headerStyle: (colum, colIndex) => {
                    return { width: "130px", fontSize: "13px" };
                },
                sort: true,
                formatter: (cell, row) => {
                    return (
                        <span>
                            {cell == 1
                                ? row.category === "public"
                                    ? "BHU"
                                    : "GP"
                                : cell == 2
                                    ? row.category === "public"
                                        ? "RHC"
                                        : "PPM"
                                    : ""}
                        </span>
                    );
                },
                csvFormatter: (cell, row) => {
                    return cell == 1
                        ? row.category === "public"
                            ? "BHU"
                            : "GP"
                        : cell == 2
                            ? row.category === "public"
                                ? "RHC"
                                : "PPM"
                            : "";
                },
                // formatter: (cell, row) => <span>{(+cell === 1 && 'BHU/GP') || (+cell === 2 && 'RHC/PPM')}</span>,
                // hidden: this.props.UserAuthentication.UserInfo?.roleId === 8 ? false : true,
                csvExport: true,
            },
            {
                dataField: "name",
                text: "Name",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "90px", fontSize: "13px" };
                },
            },
            {
                dataField: "contact",
                text: "Contact",
                headerStyle: (colum, colIndex) => {
                    return { width: "79px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "gender",
                text: "Gender",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "75px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return (
                        <span>{cell === 1 ? "Male" : cell === 2 ? "Female" : "Other"}</span>
                    );
                },
                csvFormatter: (gender) =>
                    gender === 1 ? "Male" : gender === 2 ? "Female" : "Other",
            },
            {
                dataField: "age",
                text: "Age",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
                csvFormatter: (age) => (age == null ? "" : age),
            },
            {
                dataField: "is_registered",
                text: "Registered/Not-Registered",
                sort: true,
                formatter: (cell, row) => {
                    return (
                        <div className="col-md-6 col-lg-3" style={{ marginTop: "10px" }}>
                            <label className="CheckBox_container Roles_CheckBox">
                                {/*<span>{row.is_registered ? 'Registered' : 'Not Registered'}</span>*/}
                                <input
                                    type="checkbox"
                                    onChange={(e) =>
                                        this.RegisterUnregisterPatient(row.id, e.target.checked)
                                    }
                                    defaultChecked={row.is_registered}
                                />
                                <span className="CheckBox_checkmark"></span>
                            </label>
                        </div>
                    );
                },
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                csvFormatter: (age) => (age == null ? "" : age),
            },
            {
                dataField: "cnic",
                text: "CNIC/B-Form #",
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "address",
                text: "Address",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
                csvFormatter: (address) => (address == null ? "" : address),
            },
            {
                dataField: "is_clinicallyDiagnosed",
                text: "Clinically Diagnosed",
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return (
                        <div className="text-center" style={{ marginTop: "10px" }}>
                            <label className="CheckBox_container Roles_CheckBox">
                                {/*<span>{row.is_clinicallyDiagnosed ? 'Diagnosed' : 'Not Diagnosed'}</span>*/}
                                <input
                                    type="checkbox"
                                    onChange={(e) =>
                                        this.UpdatePatientDiagnosed(row.id, e.target.checked)
                                    }
                                    defaultChecked={row.is_clinicallyDiagnosed}
                                />
                                <span className="CheckBox_checkmark"></span>
                            </label>
                        </div>
                    );
                },
            },
            {
                dataField: "creationDateTime",
                text: "Created At",

                formatter: (cell, row) => {
                    return Common.ConvertToLocalDateTime(cell);
                },
                csvFormatter: (creationDateTime) =>
                    Common.ConvertToLocalDateTime(creationDateTime),
                headerStyle: (colum, colIndex) => {
                    return { width: "180px", fontSize: "13px" };
                },
                sort: true,
            },
            {
                dataField: "",
                text: "Actions",
                // hidden:true,
                headerStyle: (colum, colIndex) => {
                    return { width: "75px" };
                },
                formatter: (cell, row) => {
                    return CellMenu(cell, row);
                },
                csvExport: false,
                // hidden: this.props.UserAuthentication.UserInfo?.roleId == 1 || this.props.UserAuthentication.UserInfo?.roleId == 8 ? true : false
            },
        ];

        return (
            <div>
                <AlertModal {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" class="right-panel">
                    <Topmenu
                        PageTitle="Patients"
                        isShowAddBtn={
                            this.props.UserAuthentication.UserInfo?.roleId === 1 ||
                                this.props.UserAuthentication.UserInfo?.roleId == 8
                                ? false
                                : true
                        }
                        AddBtnLabel="Add Patient"
                        AddBtnLink="/Patients_Add"
                    />
                    <div class="content">
                        <div class="card">
                            <div class="card-body">
                                <div className="Table_Search row">
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Province</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="ProvinceId"
                                            options={this.state.Provincelist}
                                            val={this.state.ProvinceId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.ProvinceLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Sub Recipient</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="SrId"
                                            options={this.state.FilteredSrs}
                                            val={this.state.SrId}
                                            addPlaceholder=""
                                            disabled={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">District</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="DistrictId"
                                            options={this.state.FilteredDistrictlist}
                                            val={this.state.DistrictId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.DistrictLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                        <label htmlFor="">Patient Name</label>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control Search_InputField"
                                            id="SearchName"
                                            placeholder="Patient Name"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                        <label htmlFor="">Patient Contact</label>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control Search_InputField"
                                            id="SearchContact"
                                            placeholder="Patient Contact"
                                        />
                                    </div>
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                        <label htmlFor="">Gender</label>
                                        <select
                                            name="category"
                                            id="gender"
                                            className="form-control"
                                        >
                                            <option value="" selected>
                                                All
                                            </option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                        </select>
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-2 col-sm-12 col-xs-12">
                                        <label htmlFor="">Facility Type</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer={false}
                                            create={false}
                                            onChange={(field, value) => {
                                                const category =
                                                    String(value).charAt(2) === "b"
                                                        ? "private"
                                                        : "public";
                                                this.setState({ [field]: value, category });
                                            }}
                                            Type="facilityTypeId"
                                            options={this.state.facilityTypes}
                                            val={this.state.facilityTypeId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={false}
                                            placeholder="Select"
                                        />
                                    </div>
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-2 col-sm-12 col-xs-12">
                                        <label htmlFor="">Patient SampleID</label>
                                        <input
                                            type="number"
                                            id="sampleId"
                                            className="form-control"
                                            placeholder="Sample ID"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">From</label>
                                        <DatePicker
                                            selected={this.state.startDate}
                                            onChange={(date) => {
                                                this.HandleDateChange("startDate", date);
                                            }}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">To</label>
                                        <DatePicker
                                            selected={this.state.endDate}
                                            onChange={(date) => {
                                                this.HandleDateChange("endDate", date);
                                            }}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            minDate={this.state.startDate}
                                        />
                                    </div>
                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <button
                                            style={{ marginTop: "35px" }}
                                            onClick={() => {
                                                this.PopulateTable();
                                            }}
                                            id="FormSearchBtn"
                                            className={"btn btn-primary"}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>

                                {this.state.csvFileLink && (
                                    <p>
                                        <a id="btnDownload" href={this.state.csvFileLink} download="sheet.csv">
                                            Download CSV File
                                        </a>
                                    </p>
                                )}

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    isPagination={true}
                                    changeSizePerPage={(size) => {
                                        setTimeout(() => {
                                            this.setState({
                                                exportLoading: true,
                                            });
                                            this.ExportData(size);
                                        }, 1000);
                                    }}
                                    exportAllowed={this.state.permissions.includes(
                                        "patient-export"
                                    )}
                                    exportPdf={this.ExportPdf}
                                    pdfExportLoading={this.state.exportingPdf}
                                    columns={columns}
                                    loading={this.state.loading}
                                    RefreshTable={this.PopulateTable}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Patients_List);
